import React from 'react'
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController'
import { CustomInputLable, InputContainer, ParentContainerSection } from '../FootForm'
import { summary_risk_rating_options } from './formFootOptions'

const FootSummary = (props) => {
    const {control, errors, getValues} = props
  return (
    <>
    <ParentContainerSection heading="Section J - Summary Risk Rating for Diabetic Foot Complications">
    <InputContainer  >
          <CustomInputLable required>Risk Rating</CustomInputLable>
           
                  <RadioButtonController
                                    name="risk_rating"
                                    control={control}
                                    errors={errors}
                                    options={summary_risk_rating_options}
                                    isRow={false}
                                    isDisabled={true}
                            />
            </InputContainer>
            </ParentContainerSection>
    </>
  )
}

export default FootSummary